import { Branch } from "~/_legacy/types/common";
import { WithBranchParams } from "~/_legacy/types/params";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string) => `branches/${branchUid}/branch-config/`;

export const updateBranchConfig = async ({
  branchUid,
  branchVersionId,
  config,
}: WithBranchParams<Partial<Pick<Branch, "config">>>) => {
  const url = createApiUrl(branchUid);
  const { data } = await axiosInstance.patch(url, {
    version: branchVersionId,
    status: config?.status,
  });

  return data;
};
